<div class="full-page bg-primary w-100">
  <div class="text-center">
    <img class="logo" aria-labelledby="homeLink" [src]="'logo/club-bear-logo.svg' | contentAssetImage" draggable="false" />
    <div class="terms-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
